// @ts-nocheck
import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Clipboard from 'react-clipboard.js';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import Section from 'components/Section';
import { TableContainer, Table, TableHead, TableRow, TableCell, CardContent, TableBody,TextField, Button, Select, MenuItem, InputLabel, FormControl, Dialog, DialogTitle, DialogContent, DialogActions, InputAdornment, IconButton, CircularProgress } from '@mui/material';

import PdfDialog from 'components/PdfDialog';
import { useDispatch } from 'react-redux';
import { teal, penly } from 'api';
import { getAllMeetings, getConversations } from 'actions/access';
import { config } from 'utils/config';
import { renderDateLong, renderTime, renderKr, capitalizeFirstLetter } from 'utils/formatter';
import { statusOptions } from 'utils/constants';
import { useLoading } from 'hooks/useLoading';

import User from 'components/access/User';
import OrderProgressStepper from 'components/ProgressStepper/OrderProgressStepper';
// import LawOrderProgressStepper from 'components/ProgressStepper/LawOrderProgressStepper';
import PenlyAccessUser from 'pages/PenlyAccessUser';
import PenlyAccessLegacyNotes from 'pages/PenlyAccessLegacyNotes';
import PenlyAccessMessages from 'pages/PenlyAccessMessages';
import { renderDate } from 'utils/helpers';
import CreateOrderButton from 'components/access/CreateOrderButton';
import { findMeetingsByEmail } from 'components/access/services/meetingsLookup';
import { GridCard, GridContainer } from '../components/mui/Grid';
import { findBestAdvisorForBookings } from './PenlyAccessOrder.advisorMatching.helpers';
import { buildRequestedSharingScopesFromOrder, getEffectiveOrderSharings, isOrderSharingMissing } from './PenlyAccessOrder.sharing.helpers';

const getMeetingDateText = (meeting) => {
    const startTime = meeting?.booking?.startTime || meeting?.booking?.calendlyEvent?.start_time;
    if (!startTime) {
        return 'Tidspunkt ikke angivet';
    }

    return new Date(startTime).toLocaleString('da-DK', {
        dateStyle: 'medium',
        timeStyle: 'short',
    });
};

const getCustomerName = (customer = {}) => {
    const nestedName = customer?.name;
    if (typeof nestedName === 'string' && nestedName.trim()) return nestedName.trim();

    const firstName = customer?.firstName || nestedName?.firstName || customer?.givenName || customer?.contact?.firstName;
    const lastName = customer?.lastName || nestedName?.lastName || customer?.familyName || customer?.contact?.lastName;
    const fullName = [firstName, lastName].filter(Boolean).join(' ').trim();

    return fullName || customer?.fullName || nestedName?.fullName || '';
};

const getCustomerPhone = (customer = {}) => (
    customer?.phone
    || customer?.phoneNumber
    || customer?.mobile
    || customer?.mobilePhone
    || customer?.contact?.phone
    || customer?.contact?.phoneNumber
    || ''
);

const getCustomerAddress = (customer = {}) => {
    const nestedAddress = customer?.address || customer?.residence || customer?.contact?.address;

    if (typeof nestedAddress === 'string' && nestedAddress.trim()) return nestedAddress.trim();

    const line1 = [
        nestedAddress?.address || nestedAddress?.street || nestedAddress?.streetName || customer?.addressLine1 || customer?.street,
        nestedAddress?.addressLine2 || customer?.addressLine2,
    ].filter(Boolean).join(', ');

    const line2 = [
        nestedAddress?.zipCode || nestedAddress?.postalCode || customer?.zipCode || customer?.postalCode,
        nestedAddress?.city || customer?.city,
    ].filter(Boolean).join(' ');

    return [line1, line2].filter(Boolean).join(', ');
};

const getMeetingTitleText = (meeting) => {
    const orderNumber = meeting?.order?.orderNumber ? `#${meeting.order.orderNumber}` : null;
    const customerName = getCustomerName(meeting?.order?.customer || {});
    const advisorName = meeting?.booking?.vendorsAttendees?.join(', ');

    return [orderNumber, customerName || 'Ukendt kunde', advisorName].filter(Boolean).join(' · ');
};

const PenlyAccessOrder = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { organisationId, orderId } = useParams();
    const [order, setOrder] = useState();
    const [snack, setSnack] = useState();
    const [pdf, setPdf] = useState();
    const [users, setUsers] = useState([]);
    const [partnerUser, setPartnerUser] = useState();
    const [, setPartnerFiles] = useState([]);
    const [, setPartnerSharings] = useState([]);
    const [showPartnerSharingModal, setShowPartnerSharingModal] = useState(false);
    const [requestingPartnerSharing, setRequestingPartnerSharing] = useState(false);
    const [requestingOrderSharing, setRequestingOrderSharing] = useState(false);
    const [fallbackOrderSharings, setFallbackOrderSharings] = useState([]);

    const [status, setStatus] = useState();
    const [assignedTo, setAssignedTo] = useState('');
    const [advisors, setAdvisors] = useState([]);
    const [updatingAdvisor, setUpdatingAdvisor] = useState(false);
    const [findMeetingsModalOpen, setFindMeetingsModalOpen] = useState(false);
    const [emailQuery, setEmailQuery] = useState('');
    const [emailSearchTouched, setEmailSearchTouched] = useState(false);
    const [matchedMeetings, setMatchedMeetings] = useState([]);
    const [loadingMeetings, setLoadingMeetings] = useState(false);
    const [legacyNotes, setLegacyNotes] = useState([]);
    const latestMeetingSearchIdRef = useRef(0);
    const lastCompletedMeetingSearchEmailRef = useRef('');
    const setLoading = useLoading();

    const setOrderStatus = async (value) => {
        try {
            await teal.updateOrder(organisationId, orderId, { status: value });
            setStatus(value);
        } catch (error) {
            alert('kunne ikke opdatere ordre status');
        }
    };

    const getAdvisorId = (advisor) => advisor?.id || advisor?.userId || '';
    const getAdvisorName = (advisor) => advisor?.name || `${advisor?.firstName || ''} ${advisor?.lastName || ''}`.trim();

    const setOrderAdvisor = async (advisorId) => {
        const advisor = advisors.find(user => getAdvisorId(user) === advisorId);
        try {
            setUpdatingAdvisor(true);
            const nextAssignedTo = advisor
                ? {
                    userId: getAdvisorId(advisor),
                    name: getAdvisorName(advisor),
                    email: advisor.email,
                }
                : null;

            const updatedOrder = await teal.updateOrder(organisationId, orderId, {
                assignedTo: nextAssignedTo,
                assignedAdvisor: nextAssignedTo ? { userId: nextAssignedTo.userId, name: nextAssignedTo.name } : null,
            });

            setOrder(prevOrder => ({ ...prevOrder, ...updatedOrder }));
            setAssignedTo(nextAssignedTo?.userId || '');
            setSnack({ message: 'Rådgiver opdateret', severity: 'success' });
        } catch (error) {
            setSnack({ message: 'Kunne ikke opdatere rådgiver', severity: 'error' });
        } finally {
            setUpdatingAdvisor(false);
        }
    };
    const getAffiliateIdFromOrder = (order) => {
        if(!order) return null;
        // Iterate through each item in the order
        // eslint-disable-next-line
        for (const item of order.items) {
            if (item.product && item.product.affiliateId) {
                // Return the first affiliateId found
                return item.product.affiliateId;
            }
        }

        // Return null if no affiliateId is found
        return null;
    };
    useEffect(() => {
        const fetch = async () => {
            setLoading('Indlæser ordre');
            const [order, organisationUsers] = await Promise.all([
                teal.getOrder(organisationId, orderId),
                teal.getUsersInOrganisation(organisationId),
            ]);

            let resolvedFallbackOrderSharings = [];
            if (order?.customer?.userId && (order?.sharings?.length ?? 0) === 0) {
                try {
                    resolvedFallbackOrderSharings = await teal.getSharings(organisationId, order.customer.userId);
                } catch (error) {
                    resolvedFallbackOrderSharings = [];
                }
            }
            setFallbackOrderSharings(resolvedFallbackOrderSharings || []);

            const effectiveOrderSharings = getEffectiveOrderSharings(order, resolvedFallbackOrderSharings);
            const conversations = order?.customer?.userId
                ? await dispatch(getConversations(organisationId, order.customer.userId))
                : [];
            const legacyMessages = (conversations || [])
                .filter(x => x.audience === 'importer' && x.type !== 'ai')
                .flatMap(conversation => conversation?.messages || []);
            const mappedLegacyNotes = legacyMessages.map((message, index) => ({
                ...message,
                content: message?.content ?? message?.message?.content ?? '',
                isLegacyNote: true,
                legacyId: `legacy-note-${message?._id || index}`,
                createdAt: message?.createdAt || message?.date,
                createdBy: message?.createdBy || (message?.sender?.userId ? { userId: message.sender.userId } : undefined),
            }));

            let users = [];
            if (effectiveOrderSharings.length > 0) {
                const userIds = [...new Set(effectiveOrderSharings.reduce(
                    (accumulator, sharing) => sharing?.exporter?.userId ? [...accumulator, sharing.exporter.userId] : accumulator,
                    [],
                ))];
                users = await Promise.all(userIds.map(async userId => {
                    const user = await penly.getUser(organisationId, userId);
                    const files = await penly.getFiles(organisationId, userId);
                    return { ...user, data: { ...user.data, files } };
                }));
            }

            const primaryUser = users.find(u => u.userId === order?.customer?.userId);
            const partnerEmail = primaryUser?.data?.household?.partner?.email;

            if (partnerEmail && primaryUser) {
                try {
                    const partner = await penly.getUserByEmail(organisationId, partnerEmail);
                    const [partnerFiles, sharings] = await Promise.all([
                        penly.getFiles(organisationId, partner.userId),
                        teal.getSharings(organisationId, partner.userId),
                    ]);

                    setPartnerUser(partner);
                    setPartnerFiles(partnerFiles || []);
                    setPartnerSharings(sharings || []);

                    const normalizedPartnerFiles = (partnerFiles || []).map(file => ({ ...file, fromPartnerProfile: true }));
                    users = users.map(user => {
                        if (user.userId !== primaryUser.userId) return user;
                        return {
                            ...user,
                            data: {
                                ...user.data,
                                files: [...(user.data?.files || []), ...normalizedPartnerFiles],
                            },
                        };
                    });
                } catch (error) {
                    setPartnerUser(undefined);
                    setPartnerFiles([]);
                    setPartnerSharings([]);
                }
            } else {
                setPartnerUser(undefined);
                setPartnerFiles([]);
                setPartnerSharings([]);
            }

            setUsers(users);
            setAdvisors(organisationUsers || []);
            let nextOrder = order;
            const currentAssignedAdvisorId = order?.assignedTo?.userId || order?.assignedAdvisor?.userId;

            if (!currentAssignedAdvisorId) {
                const matchedAdvisor = findBestAdvisorForBookings(order, organisationUsers || []);
                const matchedAdvisorId = getAdvisorId(matchedAdvisor);

                if (matchedAdvisorId) {
                    const matchedAssignedTo = {
                        userId: matchedAdvisorId,
                        name: getAdvisorName(matchedAdvisor),
                        email: matchedAdvisor?.email,
                    };

                    try {
                        nextOrder = await teal.updateOrder(organisationId, orderId, {
                            assignedTo: matchedAssignedTo,
                            assignedAdvisor: { userId: matchedAssignedTo.userId, name: matchedAssignedTo.name },
                        });
                    } catch (error) {
                        setSnack({ message: 'Kunne ikke sætte rådgiver automatisk', severity: 'error' });
                    }
                }
            }

            setOrder(nextOrder);
            setLegacyNotes(mappedLegacyNotes);
            setStatus(nextOrder.status);
            setAssignedTo(nextOrder.assignedTo?.userId || nextOrder.assignedAdvisor?.userId || '');
            setLoading(false);
        };
        fetch();
    }, [orderId, setLoading]);

    // remove showCalendlyBookingEventLink and single calendlyBookingLink; derive unique calendly links per order item instead
    const calendlyLinks = (order && Array.isArray(order.items))
        ? (() => {
            // collect urls from product.receipt.cta.url and product.receipt.cta.customerChoiceUrl
            const rawLinks = order.items.flatMap(i => {
                const links = [];
                const cta = i.product && i.product.receipt && i.product.receipt.cta;
                if (cta && cta.url) links.push(cta.url);
                if (cta && cta.customerChoiceUrl) links.push(cta.customerChoiceUrl);
                return links;
            }).filter(Boolean);
            // unique urls
            const unique = [...new Set(rawLinks)];
            // map to objects with product names (there can be multiple products using same link)
            return unique.map(link => {
                const productNames = order.items
                    .filter(i => {
                        const cta = i.product && i.product.receipt && i.product.receipt.cta;
                        return (cta && (cta.url === link || cta.customerChoiceUrl === link));
                    })
                    .map(i => i.product && i.product.name)
                    .filter(Boolean);
                return { link, productNames: [...new Set(productNames)] };
            });
        })()
        : [];

    // use first penly booking id as before for linking bookingId to order (if present)
    const defaultPenlyBookingId = order?.calendlyBookingIds?.[0];
    const handleCancelProduct = async (index) => {
        try {
            const items = order.items.filter((_,i) => i !== index);
            const updatedOrder = await teal.updateOrder(organisationId, order.orderId, { items });
            setOrder(updatedOrder);
        } catch (error) {
            alert('kunne ikke opdatere ordre status');
        }
    };

    const handleRequestDataSharing = async () => {
        try {
            await penly.createInvitation(organisationId, order);
            setSnack({ message: 'Anmodning om datadeling sendt på mail', severity: 'success' });
        } catch (error) {
            setSnack({ message: 'Kunne ikke sende anmodning om datadeling', severity: 'error' });
        }
    };

    const handleRequestOrderSharing = async () => {
        const recipientEmail = order?.customer?.email?.trim();
        const recipientName = getCustomerName(order?.customer || {});
        const recipientFirstName = order?.customer?.firstName || recipientName?.split(' ')[0] || '';

        if (!recipientEmail) {
            setSnack({ message: 'Kunden mangler en emailadresse, så deling kan ikke anmodes endnu', severity: 'error' });
            return;
        }

        try {
            setRequestingOrderSharing(true);
            await teal.createSharing(organisationId, {
                recipient: {
                    email: recipientEmail,
                    name: recipientName || recipientEmail,
                    firstName: recipientFirstName,
                },
                requestedScopes: buildRequestedSharingScopesFromOrder(order),
                message: 'Din rådgiver har anmodet om adgang til dine oplysninger i Penly, så rådgivningen kan fortsætte.',
            });

            const updatedOrder = await teal.getOrder(organisationId, orderId);
            setOrder(updatedOrder);
            setSnack({ message: 'Anmodning om deling er sendt', severity: 'success' });
        } catch (error) {
            setSnack({ message: 'Kunne ikke sende anmodning om deling', severity: 'error' });
        } finally {
            setRequestingOrderSharing(false);
        }
    };

    const handleRequestPartnerSharing = async () => {
        if (!partnerUser) return;
        try {
            setRequestingPartnerSharing(true);
            await teal.createSharing(organisationId, {
                recipient: {
                    email: partnerUser.email,
                    name: `${partnerUser.firstName || ''} ${partnerUser.lastName || ''}`.trim(),
                },
                requestedScopes: [
                    {
                        type: 'self',
                        basic: { all: true },
                        pension: { all: true },
                        income: { all: true },
                        relations: { all: true },
                        savings: { all: true },
                        surveys: { all: true },
                        budget: { all: true },
                        debt: { all: true },
                        properties: { all: true },
                        insurance: { all: true },
                    },
                ],
                message: 'Din rådgiver har anmodet om adgang til dine oplysninger, så rådgivningen kan omfatte jer begge.',
                type: 'partner-request',
            });
            const sharings = await teal.getSharings(organisationId, partnerUser.userId);
            setPartnerSharings(sharings || []);
            setShowPartnerSharingModal(false);
            setSnack({ message: 'Anmodning om partner-deling er sendt', severity: 'success' });
        } catch (error) {
            setSnack({ message: 'Kunne ikke sende anmodning om partner-deling', severity: 'error' });
        } finally {
            setRequestingPartnerSharing(false);
        }
    };

    const isUserCreated = Boolean(order?.customer?.userId);

    const penlyOrderPageLink = generatePenlyOrderPageLink(config.penlyBaseUrl, isUserCreated, order?.orderId, order?.customer?.email);

    const { customer = {}, error, orderNumber, message, createdAt, createdBy } = order || { };
    const customerDisplayName = getCustomerName(customer);
    const customerDisplayEmail = customer?.email || customer?.contact?.email || '';
    const customerDisplayPhone = getCustomerPhone(customer);
    const customerDisplayAddress = getCustomerAddress(customer);
    const customerEmail = customerDisplayEmail?.trim().toLowerCase() || '';
    const normalizedEmailQuery = emailQuery.trim().toLowerCase();
    const emailLooksValid = /^\S+@\S+\.\S+$/.test(normalizedEmailQuery);
    const toRenderableMessage = (value) => {
        if (value === null || value === undefined) {
            return '';
        }

        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            return String(value);
        }

        if (typeof value === 'object') {
            const messageCandidate = value || {};
            const nestedMessage = messageCandidate.message ?? messageCandidate.text;

            if (nestedMessage !== undefined && nestedMessage !== value) {
                return toRenderableMessage(nestedMessage);
            }

            return JSON.stringify(value);
        }

        return String(value);
    };

    const renderableMessage = toRenderableMessage(message);
    const effectiveOrderSharings = getEffectiveOrderSharings(order, fallbackOrderSharings);
    const isLaw = hasLawProduct(order);
    const missingOrderSharing = !isLaw && isOrderSharingMissing(order, fallbackOrderSharings);
    const affiliate = getAffiliateIdFromOrder(order);
    const calendlyQuestion = order?.bookings[0]?.calendlyEvent?.invitees?.questions_and_answers[0]?.question;
    const calendlyAnswer = order?.bookings[0]?.calendlyEvent?.invitees?.questions_and_answers[0]?.answer;

    const openFindMeetingsModal = () => {
        setFindMeetingsModalOpen(true);
        setEmailQuery(customerEmail || '');
        setEmailSearchTouched(true);
        setMatchedMeetings([]);
        lastCompletedMeetingSearchEmailRef.current = '';
    };

    useEffect(() => {
        if (!findMeetingsModalOpen) {
            return;
        }

        latestMeetingSearchIdRef.current += 1;
        const activeSearchId = latestMeetingSearchIdRef.current;

        if (!normalizedEmailQuery) {
            setMatchedMeetings([]);
            setLoadingMeetings(false);
            return;
        }

        if (!emailLooksValid) {
            setMatchedMeetings([]);
            setLoadingMeetings(false);
            return;
        }

        if (lastCompletedMeetingSearchEmailRef.current === normalizedEmailQuery) {
            return;
        }

        const timeoutId = setTimeout(async () => {
            try {
                setLoadingMeetings(true);
                const nextMatches = await findMeetingsByEmail({
                    organisationId,
                    email: normalizedEmailQuery,
                    getUserByEmail: penly.getUserByEmail,
                    getAllMeetings: async (targetOrganisationId) => dispatch(getAllMeetings(targetOrganisationId)),
                });

                if (activeSearchId !== latestMeetingSearchIdRef.current) {
                    return;
                }

                setMatchedMeetings(nextMatches);
                lastCompletedMeetingSearchEmailRef.current = normalizedEmailQuery;
            } finally {
                if (activeSearchId === latestMeetingSearchIdRef.current) {
                    setLoadingMeetings(false);
                }
            }
        }, 300);

        return () => {
            clearTimeout(timeoutId);
        };
    }, [dispatch, emailLooksValid, findMeetingsModalOpen, normalizedEmailQuery, organisationId]);

    const closeFindMeetingsModal = () => {
        setFindMeetingsModalOpen(false);
        setLoadingMeetings(false);
        setEmailSearchTouched(false);
        setMatchedMeetings([]);
    };

    const openMeetingOrder = (targetOrderId) => {
        if (!targetOrderId) {
            return;
        }
        closeFindMeetingsModal();
        navigate(`/${organisationId}/access/orders/${targetOrderId}`);
    };
    return (
        <div className="App-content" style={{ marginTop: 20 }}>
            { error === 'NotFound' && (
                <Paper sx={{ p: 3, my: 3, boxShadow: '-10px 10px 20px 0 rgba(30, 30, 30, 0.05)' }}>
                    <p>Ordren eksisterer ikke. Gå tilbage for at finde hvad du leder efter.</p>
                </Paper>
            ) }
            { orderNumber && (
                <>
                    <Paper
                        sx={{
                            p: 3,
                            my: 3,
                            width: 1100,
                            maxWidth: 'calc(100% - 60px)',
                            boxShadow: '-10px 10px 20px 0 rgba(30, 30, 30, 0.05)',
                            '@media print': {
                                width: '100%',
                                maxWidth: '100%',
                                boxShadow: 'none',
                                overflow: 'visible',
                            },
                        }}
                    >
                        <Box display='flex' sx={{ my: 1 }}>
                            <Typography variant="h2">{ `Ordre #${order.orderNumber}` }</Typography>
                            <FormControl variant="standard" sx={{ m: 1, minWidth: 220, ml: 'auto' }}>
                                <InputLabel id="advisor-label">Rådgiver</InputLabel>
                                <Select
                                    labelId="advisor-label"
                                    value={ assignedTo }
                                    onChange={ (e) => setOrderAdvisor(e.target.value) }
                                    label="Rådgiver"
                                    disabled={ updatingAdvisor }
                                >
                                    <MenuItem value="">Ingen</MenuItem>
                                    { advisors.map((advisor) => {
                                        const advisorId = getAdvisorId(advisor);
                                        const advisorName = getAdvisorName(advisor);
                                        return (
                                            <MenuItem key={ advisorId || advisor.email } value={ advisorId }>
                                                { advisorName || advisor.email || advisorId }
                                            </MenuItem>
                                        );
                                    }) }
                                </Select>
                            </FormControl>
                            <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                                <InputLabel id="status-label">Status</InputLabel>
                                <Select
                                    labelId="status-label"
                                    value={ status }
                                    onChange={ (e) => setOrderStatus(e.target.value) }
                                    label="Status"
                                >
                                    { statusOptions.map((status) => (
                                        <MenuItem key={ status.value } value={ status.value }>
                                            { status.name }
                                        </MenuItem>
                                    )) }
                                </Select>
                            </FormControl>
                            { isLaw &&
                            <Button sx={{ ml: 'auto', displayPrint: 'none' }} onClick={ window.print } variant="contained" endIcon={ <PrintOutlinedIcon /> }>Print</Button>

                            }
                        </Box>

                        <Divider sx={{ my: 3 }} />

                        <GridContainer>
                            <GridCard>
                                <CardContent>
                                    <Typography variant='h5'>{ isLaw ? 'Basisinformation' : 'Kunde' }</Typography>
                                    { createdAt && (<p><strong>Bestillingsdato: </strong>{ renderDate(createdAt, false) }</p>) }
                                    { customerDisplayName && (<p><strong>Navn:</strong> { customerDisplayName }</p>) }
                                    { customerDisplayEmail && (<p><strong>Email:</strong> { customerDisplayEmail }</p>) }
                                    { customerDisplayPhone && (<p><strong>Telefon:</strong> { customerDisplayPhone }</p>) }
                                    { customerDisplayAddress && (<p><strong>Adresse:</strong> { customerDisplayAddress }</p>) }
                                    { affiliate && (<p><strong>Affiliate:</strong> { affiliate }</p>) }
                                    { createdBy?.name && (<p><strong>Oprettet af:</strong> { createdBy.name }</p>) }

                                </CardContent>
                            </GridCard>


                            <GridCard>
                                <CardContent>
                                    <Typography variant='h5'>Produkter</Typography>
                                    { order.items.map((item,i) => (
                                        <div key={ item.productId }>
                                            <p>{ item.quantity } x { item.product.name } til { }
                                                { item.product.addedByAdvisor &&
                                                <Button variant="text" color="error" onClick={ () => handleCancelProduct(i) }>Annuller</Button>

                                                }
                                            </p>

                                            { /* Show customerChoiceUrl link if present on product.receipt.cta */ }
                                            { item.product?.receipt?.cta?.customerChoiceUrl && (
                                                <Clipboard style={{ marginTop: 8 }} component='div' data-clipboard-text={ item.product.receipt.cta.customerChoiceUrl }>
                                                    <TextField
                                                        variant="outlined"
                                                        value={ item.product.receipt.cta.customerChoiceUrl }
                                                        fullWidth
                                                        sx={{
                                                            '& .MuiInputBase-input': {
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                            },
                                                        }}
                                                        InputProps={{
                                                            readOnly: true,
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    <IconButton edge="end">
                                                                        <ContentCopyIcon />
                                                                    </IconButton>
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                    />
                                                </Clipboard>
                                            ) }

                                        </div>
                                    )) }
                                    { /* <AddProductsModalButton isLaw={ isLaw } order={ order } onClick={ (updatedOrder) =>  setOrder(updatedOrder) }/> */ }
                                    <CreateOrderButton isLaw={ isLaw } customer={ order.customer }></CreateOrderButton>

                                </CardContent>
                            </GridCard>

                            <GridCard>
                                <CardContent>

                                    { order.bookings.length ? (
                                        <>
                                            <Typography variant='h5'>Fremtidigt møde</Typography>
                                            { order.bookings.map(booking => (
                                                <div key={ booking.bookingId }>
                                                    <p>
                                                        { capitalizeFirstLetter(renderDateLong(booking.startTime)) }, kl. { renderTime(booking.startTime) } - { renderTime(booking.endTime) } med { booking.vendorsAttendees.join(' og ') }
                                                    </p>
                                                </div>
                                            )) }
                                        </>
                                    ) : (
                                        <>
                                            <Typography variant='h5'>Ingen fremtidige møder</Typography>

                                            { /* Render all unique calendly links found on the order (product-level) */ }
                                            { calendlyLinks.length > 0 && (
                                                <>
                                                    <Typography variant='h6'>Kundens links til booking af møde:</Typography>
                                                    { calendlyLinks.map(({ link, productNames }) => {
                                                        const generated = generateCalendlyBookingId(
                                                            link,
                                                            defaultPenlyBookingId,
                                                            {
                                                                email: order?.customer?.email,
                                                                name: `${order?.customer.firstName} ${order?.customer.lastName}`,
                                                            },
                                                        );
                                                        // show fixed title when link is a customerChoiceUrl
                                                        const isCustomerChoice = order.items.some(i => {
                                                            const cta = i.product && i.product.receipt && i.product.receipt.cta;
                                                            return !!(cta && cta.customerChoiceUrl === link);
                                                        });
                                                        const title = isCustomerChoice ? 'Vælg rådgiver' : productNames.join(', ');
                                                        return (
                                                            <div key={ link } style={{ marginBottom: 12 }}>
                                                                <Typography variant='subtitle2' sx={{ mb: 1 }}>
                                                                    { title }
                                                                </Typography>
                                                                <Clipboard style={{ display: 'flex' }} component='div' data-clipboard-text={ generated }>
                                                                    <TextField
                                                                        variant="outlined"
                                                                        value={ generated }
                                                                        sx={{
                                                                            '& .MuiInputBase-input': {
                                                                                overflow: 'hidden',
                                                                                textOverflow: 'ellipsis',
                                                                            },
                                                                        }}
                                                                        disabled
                                                                    />
                                                                    <Button
                                                                        variant="contained"
                                                                        endIcon={ <ContentCopyIcon /> }
                                                                        sx={{ ml: 1 }}
                                                                    >
                                                                        Copy
                                                                    </Button>
                                                                </Clipboard>
                                                            </div>
                                                        );
                                                    }) }
                                                </>
                                            ) }

                                            <Button
                                                onClick={ openFindMeetingsModal }
                                                variant="outlined"
                                                sx={{ mt: 2 }}
                                            >
                                                Find bookede møder
                                            </Button>
                                        </>
                                    ) }
                                </CardContent>
                            </GridCard>
                        </GridContainer>
                        <Divider sx={{ my: 3 }} />

                        {


                            <div style={{ marginTop:30, marginBottom:30 }}>

                                { !isLaw &&

                                <>
                                    <h3>Dataindsamling status</h3>
                                    { !order.customer?.userId &&
                                    <p style={{ backgroundColor: '#f5b895', display: 'inline-block', padding:4 }}>
                                        Mangler profiloprettelse
                                    </p>
                                    }
                                    { order.customer?.userId && effectiveOrderSharings.length === 0 &&
                                    <p style={{ backgroundColor: '#f5b895', display: 'inline-block', padding:4 }}>
                                        Mangler samtykke til datadeling
                                    </p>
                                    }
                                    <OrderProgressStepper activeStep={ (order?.dataCollectionProgress?.currentStep ?? 1) - (order?.dataCollectionProgress?.completed ? 0 : 1) }></OrderProgressStepper>
                                    {
                                        !order?.dataCollectionProgress?.completed && effectiveOrderSharings.length > 0 &&
                                        <Button
                                            variant="contained"
                                            onClick={ handleRequestDataSharing }
                                            sx={{ mt: 2 }}
                                        >
                                            Anmod kunde om at færdiggøre dataindsamling
                                        </Button>
                                    }

                                </>
                                // <LawOrderProgressStepper activeStep={order.dataCollectionProgress.currentStep - (order.dataCollectionProgress.completed ? 0 : 1)}></LawOrderProgressStepper>:

                                }

                            </div>

                        }

                        <Box sx={{ displayPrint: 'none' }}>
                            <Typography variant='h6'>Kundens link til ordreside:</Typography>
                            <Clipboard component='div' data-clipboard-text={ penlyOrderPageLink }>
                                <TextField
                                    variant="outlined"
                                    value={ penlyOrderPageLink }
                                    sx={{
                                        width: '100%',
                                        maxWidth: '60%',
                                        '& .MuiInputBase-input': {
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                        },
                                    }}
                                    InputProps={{
                                        readOnly: true,
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton edge="end">
                                                    <ContentCopyIcon />
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Clipboard>
                        </Box>


                        { calendlyQuestion && calendlyAnswer &&
                        <div style={{ marginTop:20, marginBottom:20 }}>
                            <Typography variant='h6'>Calendly spørgsmål: { calendlyQuestion }</Typography>
                            <GridCard style={{ maxWidth: '60%', backgroundColor: 'rgb(238, 238, 238)' }}>

                                <CardContent>
                                    <p style={{ marginTop:0 }}> Svaret { renderDate(order.bookings[0].calendlyEvent.created_at, false) }</p>
                                    <p>{ calendlyAnswer }</p>
                                </CardContent>
                            </GridCard>

                        </div>
                        }
                        { renderableMessage && (
                            <div style={{ marginTop:20, marginBottom:20 }}>
                                <Typography variant='h6'>Besked til rådgiver:</Typography>
                                <GridCard style={{ maxWidth: 630, backgroundColor: 'rgb(238, 238, 238)' }}>
                                    <CardContent>

                                        <p>{ renderableMessage }</p>
                                    </CardContent>
                                </GridCard>

                            </div>
                        ) }
                        {  isLaw && users.map((user) => (
                            <div key={ user.userId }>
                                <Button sx={{ marginTop: 2, marginBottom: 2, displayPrint: 'none' }} variant="contained" href={ `/${organisationId}/access/users/${user.userId}` } target="_blank" rel="noopener noreferrer">Gå til profilside</Button>
                                <User user={ user } isLaw={ isLaw } />

                                { ( false && (config.env === 'dev' || config.env === 'local')) && (
                                    <Section title="Raw debug">
                                        <textarea rows={ 8 } cols={ 80 } defaultValue={ JSON.stringify(user, null, 2) }/>
                                    </Section>
                                ) }
                            </div>
                        )) }

                    </Paper>
                    <div>
                        { missingOrderSharing ? (
                            <>
                                <PenlyAccessMessages
                                    penlyUser={{ userId: order.customer?.userId }}
                                    sharings={ effectiveOrderSharings }
                                    notesOnly
                                />
                                <Section title="Deling mangler">
                                    <p>Der mangler en deling på ordren, før resten af kundens oplysninger kan vises her.</p>
                                    <Button
                                        variant="contained"
                                        onClick={ handleRequestOrderSharing }
                                        disabled={ requestingOrderSharing }
                                    >
                                        { requestingOrderSharing ? 'Sender anmodning...' : 'Anmod om ny deling' }
                                    </Button>
                                </Section>
                            </>
                        ) : (
                            <PenlyAccessUser injectedUserId={ order.customer?.userId } isLaw={ isLaw } orderSharings={ effectiveOrderSharings }/>
                        ) }
                    </div>
                    { legacyNotes.length > 0 && (
                        <Section title="Gamle noter">
                            <PenlyAccessLegacyNotes init={ legacyNotes } />
                        </Section>
                    ) }
                    { isLaw && order.productsSnapshot?.length !== 0 &&
                    <Section title="Produkttilbud" style={{ displayPrint: 'none' }}>
                        <TableContainer>
                            <Table caria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="left">Navn</TableCell>
                                        <TableCell align="left">Tilbudt Pris</TableCell>
                                        <TableCell align="left">Normal Pris</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    { order.productsSnapshot.map((product) => (
                                        <TableRow key={ product.id }>
                                            <TableCell align="left">
                                                { product.name }
                                            </TableCell>
                                            <TableCell align="left">
                                                { renderKr(product.price.now || product.price.standard || product.price.standart) }
                                            </TableCell>
                                            <TableCell align="left">
                                                { renderKr(product.price.standard || product.price.standart) }
                                            </TableCell>
                                        </TableRow>
                                    )) }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Section>
                    }

                </>
            ) }

            { (false && (config.env === 'dev' || config.env === 'local')) && (
                <Section title="Raw debug">
                    <textarea rows={ 8 } cols={ 80 } defaultValue={ JSON.stringify(order, null, 2) }/>
                </Section>
            ) }

            <Dialog
                open={ findMeetingsModalOpen }
                onClose={ closeFindMeetingsModal }
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle>Find bookede møder</DialogTitle>
                <DialogContent>
                    <Stack spacing={ 2 } sx={{ pt: 1 }}>


                        <TextField
                            value={ emailQuery }
                            onChange={ (event) => {
                                setEmailQuery(event.target.value);
                                setEmailSearchTouched(true);
                            } }
                            placeholder="kunde@eksempel.dk"
                            label="E-mail"
                            size="small"
                            fullWidth
                        />

                        { emailSearchTouched && !normalizedEmailQuery && (
                            <MuiAlert severity="warning">Indtast en e-mailadresse for at søge efter bookede møder.</MuiAlert>
                        ) }

                        { emailSearchTouched && normalizedEmailQuery && !emailLooksValid && (
                            <MuiAlert severity="warning">Indtast en gyldig e-mailadresse.</MuiAlert>
                        ) }

                        { loadingMeetings && (
                            <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
                                <CircularProgress size={ 24 } />
                            </Box>
                        ) }

                        { emailSearchTouched && !loadingMeetings && emailLooksValid && matchedMeetings.length === 0 && (
                            <MuiAlert severity="info">Ingen bookede møder fundet for den e-mail.</MuiAlert>
                        ) }

                        { !loadingMeetings && matchedMeetings.length > 0 && (
                            <List dense>
                                { matchedMeetings.map((meeting, index) => (
                                    <ListItem
                                        key={ meeting?.booking?.eventId || meeting?.order?.orderId || index }
                                        divider
                                        secondaryAction={ (
                                            <Button
                                                size="small"
                                                onClick={ () => openMeetingOrder(meeting?.order?.orderId) }
                                                disabled={ !meeting?.order?.orderId }
                                            >
                                                Tilknyt denne ordre
                                            </Button>
                                        ) }
                                    >
                                        <ListItemText
                                            primary={ getMeetingTitleText(meeting) }
                                            secondary={ getMeetingDateText(meeting) }
                                        />
                                    </ListItem>
                                )) }
                            </List>
                        ) }
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button onClick={ closeFindMeetingsModal }>Luk</Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={ showPartnerSharingModal }
                onClose={ () => !requestingPartnerSharing && setShowPartnerSharingModal(false) }
            >
                <DialogTitle>Anmod om partner-deling</DialogTitle>
                <DialogContent>
                    Der findes en partnerprofil, men ingen deling endnu. Vil du sende en anmodning om deling?
                </DialogContent>
                <DialogActions>
                    <Button onClick={ () => setShowPartnerSharingModal(false) } disabled={ requestingPartnerSharing }>Annuller</Button>
                    <Button onClick={ handleRequestPartnerSharing } variant="contained" disabled={ requestingPartnerSharing }>
                        { requestingPartnerSharing ? 'Sender...' : 'Send anmodning' }
                    </Button>
                </DialogActions>
            </Dialog>

            <Snackbar
                open={ !!snack }
                autoHideDuration={ 6000 }
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                onClose={ () => setSnack() }
            >
                <MuiAlert severity={ snack?.severity || 'success' }>{ snack?.message }</MuiAlert>
            </Snackbar>

            <PdfDialog
                pdf={ pdf }
                onClose={ setPdf }
            />
        </div>
    );
};

export default PenlyAccessOrder;

const generateCalendlyBookingId = (calendlyEventLink, penlyBookingId, { email, name }) => {
    // Use the provided calendlyEventLink when available, otherwise fallback to the configured base
    const baseLink = calendlyEventLink || config.nedsparingsCalendlyLink;
    let link = `${baseLink}?utm_term=penly-booking-id-${penlyBookingId || ''}`;
    if (email) link = `${link}&email=${encodeURIComponent(email)}`;
    if (name) link = `${link}&name=${encodeURIComponent(name)}`;
    return link;
};

const generatePenlyOrderPageLink = (penlyLink, isUserCreated, orderId, email) => {
    let link = `${penlyLink}/mit-penly/ordrer/${orderId}`;
    if (isUserCreated) return link;

    link = `${penlyLink}/opret?email=${encodeURIComponent(email)}&disableEmailField=true&destination=${encodeURIComponent(link)}`;

    return link;
};
function hasLawProduct(order) {
    // Check if the order object exists and has valid 'items' array
    if (order && order.items && Array.isArray(order.items)) {
        // Iterate over each item in the 'items' array
        // eslint-disable-next-line
        for (const item of order.items) {
            // Check if the item has a 'product' property and if it's a law-related product
            if (item.product && isLawProduct(item.product)) {
                return true; // Return true if a law-related product is found
            }
        }
    }
    return false; // Default to false if no law-related product is found or order data is invalid
}
function isLawProduct(product) {
    if (product && product.categories && Array.isArray(product.categories)) {
        return product.categories.includes('law');
    }
    return false; // Default to false if product data is invalid or category is missing
}
